import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSignal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(2.2512 3.48)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M9.75 4.76953C10.9926 4.76953 12 5.77689 12 7.01953C12 7.99875 11.3733 8.82848 10.5 9.1377V18.5195H9V9.1377C8.12673 8.82848 7.5 7.99875 7.5 7.01953C7.5 5.77689 8.50736 4.76953 9.75 4.76953ZM16.8418 0C18.4876 1.71264 19.4999 4.02559 19.5 6.57129C19.5 7.75939 19.0303 9.30188 18.3994 10.3945L17.1006 9.64453C17.6244 8.73719 18 7.45078 18 6.57129C17.9999 4.43218 17.1507 2.48645 15.7598 1.03906L16.8418 0ZM3.74023 1.03906C2.34927 2.48645 1.50007 4.43218 1.5 6.57129C1.5 7.56231 1.66358 8.95765 1.95508 9.76465L0.544922 10.2744C0.170377 9.23763 0 7.64781 0 6.57129C7.24308e-05 4.02559 1.0124 1.71264 2.6582 0L3.74023 1.03906ZM9.75 1.26953C12.9519 1.26953 15.5 4.14675 15.5 7.01953C15.5 7.64184 15.3817 8.23983 15.1641 8.79395L13.7676 8.24512C13.9184 7.86098 14 7.44902 14 7.01953C14 4.92175 12.071 2.76953 9.75 2.76953C7.42901 2.76953 5.5 4.92175 5.5 7.01953C5.5 7.44902 5.5816 7.86098 5.73242 8.24512L4.33594 8.79395C4.11832 8.23983 4 7.64184 4 7.01953C4 4.14675 6.54814 1.26953 9.75 1.26953ZM9.75 6.26953C9.33579 6.26953 9 6.60532 9 7.01953C9 7.43374 9.33579 7.76953 9.75 7.76953C10.1642 7.76953 10.5 7.43374 10.5 7.01953C10.5 6.60532 10.1642 6.26953 9.75 6.26953Z",
			fill: "currentColor"
		})
	})
});
export default SvgSignal;
